import { memo, useCallback } from "react";

import { ArticleModal, ArticlePreview } from "./components";
import { useArticleItem } from "./hooks";
import { isWithinNewPeriod } from "../utils";

import type { SupportAnnouncement } from "../";

type Props = {
	hotelID: string;
	announcement: SupportAnnouncement;
	isRead: (href: string) => boolean;
	markAsRead: (href: string) => void;
};

export const ArticleListItem = memo(({ hotelID, announcement, isRead, markAsRead }: Props) => {
	const { open, handleOpenChange, activateArticleModal } = useArticleItem();

	const isNew = isWithinNewPeriod(announcement.publishedAt) && !isRead(announcement.href);

	const handleClick = useCallback(() => {
		markAsRead(announcement.href);
		activateArticleModal();
	}, [markAsRead, announcement.href, activateArticleModal]);

	return (
		<>
			<ArticlePreview
				title={announcement.title}
				categoryLabel={announcement.categoryLabel}
				thumbnailUrl={announcement.thumbnailUrl}
				isNew={isNew}
				onClick={handleClick}
			/>
			<ArticleModal
				hotelID={hotelID}
				title={announcement.title}
				categoryLabel={announcement.categoryLabel}
				thumbnailUrl={announcement.thumbnailUrl}
				content={announcement.content}
				publishedAt={announcement.publishedAt}
				updatedAt={announcement.updatedAt}
				open={open}
				onOpenChange={handleOpenChange}
			/>
		</>
	);
});
